module.exports = __webpack_public_path__ + "static/img/err-1.80b651a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/err-1.png
// module id = KI46
// module chunks = 1